import React from 'react'
import DefaultLayout from '../DefaultLayout'

const SleepDeptWrapper = () => {
    return (
        <div className='bg-main-800 text-white py-14 sm:py-20 tracking-wider'>
            <DefaultLayout className='px-6'>
                <div className='grid gap-x-6 gap-y-10'>
                    <div>
                        <h2 className='text-2xl sm:text-4xl font-semibold leading-[calc(40px)] sm:leading-[calc(52px)] text-center sm:mb-4'>
                            まだまた顕在化されていない<br />
                            「睡眠負債」
                        </h2>
                    </div>
                    <div className='max-w-4xl mx-auto text-center'>
                        <div className='flex gap-4 items-end mb-10'>
                            <div className='w-1/2'>
                                <p className='mb-1'>睡眠時無呼吸症候群CPAC患者数</p>
                                <h3 className='font-semibold text-2xl sm:text-3xl'>40万人</h3>
                            </div>
                            <div className='w-1/2'>
                                <p className='mb-1 tracking-wider'>潜在患者数</p>
                                <h3 className='font-semibold text-2xl sm:text-3xl'>300万人</h3>
                            </div>
                        </div>
                        <div className='bg-white pt-4'>
                            <img src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//cpac.jpg' width={1200} height={600} alt='CPAC患者数遷移図' />
                        </div>
                    </div>
                </div>
            </DefaultLayout>
        </div>
    )
}

export default SleepDeptWrapper